module.exports = __webpack_public_path__ + "img/robust.4bfe31f6.png";